import React, {useEffect, useState} from 'react';
import ThreeDotsMenu from './ThreeDotsMenu.jsx';
import PropTypes from 'prop-types';
import {usePopupState} from 'material-ui-popup-state/hooks';
import {requestStores} from '../../ListOfPREditors.brick.jsx';
import UserController from '../../../controllers/UserController';
import {getAuthorizationFromDataLambda} from '../../../utils/functionSignatures';
import {BrickContext} from 'olympe';
import {LAMBDA_NAMES} from '../../../utils/constants';


/**
 * @param {ThreeDotsMenuShrunkenPR.propTypes} props
 * @return {JSX.Element}
 * @constructor
 */
export function ThreeDotsMenuShrunkenPR(props) {
    const useRequestStore = requestStores.get(props.prTag);
    const [userHasAccessToProperties, setUserHasAccessToProperties] = useRequestStore((state) => [state.userHasAccessToProperties, state.setUserHasAccessToProperties]);
    const spender = useRequestStore((state) => state.spender);
    const requester = useRequestStore((state) => state.requester);
    const companyCode = useRequestStore((state) => state.companyCode);
    const purchaseOrganization = useRequestStore((state) => state.purchaseOrganization);
    const purchasingGroup = useRequestStore((state) => state.purchasingGroup);
    const defaultPlant = useRequestStore((state) => state.defaultPlant);
    const getPR = useRequestStore((state) => state.getPurchaseRequest);


    const [authBeingFetched, setAuthBeingFetched] = useState(false);

    const popupState = usePopupState({variant: 'popover', popupId: props.prTag});

    // We check the authorization when the menu is open
    useEffect(() => {
        if (props.isAnyPRSelected) {
            setUserHasAccessToProperties(true);
            setAuthBeingFetched(false);
        } else {
            if (popupState.isOpen &&
                userHasAccessToProperties === null &&
                props.items.some((item) => item.title === 'Submit' || item.title === 'Save')) {
                setAuthBeingFetched(true);
                if (spender.value === UserController.getCurrentUserName('EZPR-USER') ||
                    requester.value === UserController.getCurrentUserName('EZPR-USER')) {
                    setUserHasAccessToProperties(true);
                    setAuthBeingFetched(false);
                } else {
                    // Set on store if this user has access to properties or not for each PR.
                    getAuthorizationFromDataLambda(
                        props.context,
                        props.context.get(LAMBDA_NAMES.GET_AUTHORIZATION_FROM_DATA),
                        UserController.getCurrentUserName('CAADAPAAM'),
                        purchaseOrganization.value,
                        purchasingGroup.value,
                        defaultPlant.value,
                        companyCode.value,
                        (result) => {
                            setAuthBeingFetched(false);
                            setUserHasAccessToProperties(JSON.parse(result), getPR().getPurchaseRequest());
                        },
                        () => {
                            console.error(`The system couldn't fetch authorization data.`);
                            setAuthBeingFetched(false);
                            setUserHasAccessToProperties(false);
                        },
                    );
                }
            }
        }
    }, [popupState.isOpen]);

    return (
        <ThreeDotsMenu
            {...props}
            loading={authBeingFetched || props.loading}
            massSubmitLoading={props.massSubmitLoading}
            massCopyLoading={props.massCopyLoading}
            massDeleteLoading={props.massDeleteLoading}
            popupState={popupState}
            isAnyPRSelected={props.isAnyPRSelected}
            style={props.style}
        />
    );
}

ThreeDotsMenuShrunkenPR.propTypes = {
    context: PropTypes.instanceOf(BrickContext).isRequired,
    prTag: PropTypes.string,
    items: PropTypes.array,
    loading: PropTypes.bool,
    massSubmitLoading: PropTypes.bool,
    massCopyLoading: PropTypes.bool,
    massDeleteLoading: PropTypes.bool,
    style: PropTypes.object,
    disabledButtons: PropTypes.object,
    isAnyPRSelected: PropTypes.bool,
};
